var _path, _path2, _ellipse, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33315 3.3335C3.22204 5.3335 3.99982 9.3335 7.99984 9.3335C11.9998 9.3335 12.7776 5.3335 12.6665 3.3335",
    stroke: "#6FA8FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 11.3335C2.6665 12.6668 3.6665 14.0002 5.33317 14.0002C6.99984 14.0002 7.99984 12.6668 7.99984 11.3335V9.3335",
    stroke: "#6FA8FF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.66634,
    cy: 3.33333,
    rx: 1.33333,
    ry: 1.33333,
    stroke: "#6FA8FF",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 3.33333C12.6667 4.06971 12.0697 4.66667 11.3333 4.66667C10.5969 4.66667 10 4.06971 10 3.33333C10 2.59695 10.5969 2 11.3333 2C12.0697 2 12.6667 2.59695 12.6667 3.33333Z",
    stroke: "#6FA8FF",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIcon);
export default __webpack_public_path__ + "static/media/doctor-icon.4fac29b42d5cca40c94903c67863ddd3.svg";
export { ForwardRef as ReactComponent };